module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-7.9824dc85.png";